import { createSelector } from '@reduxjs/toolkit';
import { setSortAndFilter } from 'component/page/search/store/search';
import { EmptyResultInfo, selectFilterState, selectMatrixFromSearchState, selectResultInfoFromSearchState, selectSortState } from 'component/page/search/store/search.selectors';
import { Pagination } from 'gql/autogen/Pagination';
import { FilterMatrix } from 'gql/autogen/FilterMatrix';
import { SortMatrix } from 'gql/autogen/SortMatrix';
import { selectScreenWidth } from 'store/slice/menu';
import { removeItemFromLocalStorage } from 'core-framework/window/storage';
import { LocalStorageKey } from 'core-framework/constant/StorageKeys';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesCategoriesFilterClickEventActivitiesFieldsV6 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesCategoriesFilterClickEventActivitiesManifestV6 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { CategoryId } from 'core/type/Category.types';
import { FilterState } from 'component/common/Filter/Filter.types';
import { Sort } from 'gql/autogen/Sort';
import { selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';

interface OwnProps {
    isLoading?: boolean;
    isNoResults?: boolean;
}

interface StateProps {
    screenWidth: number;
    sort: Sort;
    filter: FilterState;
    sortMatrix: SortMatrix;
    filterMatrix: FilterMatrix;
    page: Pagination;
    isFilterWithoutUpdatingHistory: boolean;
}

interface DispatchProps {
    setCategoriesFilter: (sort: Sort, filter: FilterState, index: number, count: number) => void;
}

export type Props = OwnProps & StateProps & DispatchProps;

export const mapStateToProps = createSelector(
    selectScreenWidth,
    selectResultInfoFromSearchState,
    selectSortState,
    selectFilterState,
    selectMatrixFromSearchState,
    selectFeatureBehaviorFromBootstrap,
    (screenWidth, resultInfo, sort, filter, matrix, feature): StateProps => {
        const sortMatrix = matrix?.sort || {};
        const filterMatrix = matrix?.filter || {};
        const page = resultInfo.pagination || EmptyResultInfo.pagination;

        return { screenWidth, sort, filter, page, sortMatrix, filterMatrix, isFilterWithoutUpdatingHistory: feature.FilterWithoutUpdatingHistory };
    },
);

export const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
    setCategoriesFilter: (sort: Sort, filter: FilterState, index: number, count: number) => {
        removeItemFromLocalStorage(LocalStorageKey.ACTIVITY_SCROLL_POSITION_KEY);
        const categoryValue = filter.valueFilterMatrix.length > 0 ? filter.valueFilterMatrix[0].values[0] : CategoryId.All;
        trackElementEvent<ActivitiesCategoriesFilterClickEventActivitiesFieldsV6>(
            ActivitiesCategoriesFilterClickEventActivitiesManifestV6.ids,
            { is_categories_tab: true, order_index: index, activities_count: count, is_sidebar: false, is_filter_bottom_sheet: false },
            { action_element_value: categoryValue, action_element_index: index + 1 },
        );
        dispatch(setSortAndFilter({ sort, filter }));
    },
});
